// first option is default option
const sortByTypes = {    
    Auto: "Auto",
    Name: "Name",
    Value: "Donation Value",    
  };

const nodeTypes = {
    donor: "donor",
    recipient: "recipient",
    category: "category"
}


  
  export {  sortByTypes, nodeTypes};